import { Document16, Close16, Reload16 } from '@cian/ui-kit/prev';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './ChatFileLoader.css';

type TChatFileLoader = {
  src: string | null;
  isOutcoming: boolean;
  isLoading?: boolean;
  withCancel?: boolean;
  withSave?: boolean;
  withReload?: boolean;
  withFileIcon?: boolean;
  onCancel?: () => void;
  onSave?: () => void;
  onReload?: () => void;
};

export const ChatFileLoader: React.FC<TChatFileLoader> = ({
  src,
  isOutcoming,
  isLoading,
  withCancel,
  withSave,
  withReload,
  withFileIcon,
  onCancel,
  onSave,
  onReload,
}) => {
  return (
    <div className={styles['container']} data-name="ChatFileLoader">
      <div
        className={classNames(styles['circle'], isLoading && styles['loader'], !isOutcoming && styles['incoming'])}
      />
      {withCancel && onCancel && (
        <button className={styles['button']} onClick={onCancel}>
          <Close16 color={isOutcoming ? 'primary_100' : 'white_100'} />
        </button>
      )}
      {withSave && src && (
        <a href={src} className={styles['button']} onClick={onSave} target="_blank" data-name="ChatFileLoader_save">
          <Document16 color={isOutcoming ? 'primary_100' : 'white_100'} />
        </a>
      )}
      {withReload && onReload && (
        <button className={styles['button']} onClick={onReload}>
          <Reload16 color={isOutcoming ? 'primary_100' : 'white_100'} />
        </button>
      )}
      {withFileIcon && !withSave && (
        <div className={styles['button']}>
          <Document16 color={isOutcoming ? 'primary_100' : 'white_100'} />
        </div>
      )}
    </div>
  );
};
